import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cloud, Check, Trash2 } from 'lucide-react';
import BackLink from '../components/BackLink';
import SiteHeader from '../components/SiteHeader';
import FooterExpanded from '../components/landing/FooterExpanded';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function AccountIntegrationsPage() {
  const [conns, setConns] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const r = await axios.get(`${API_URL}/api/cloud/connections`); setConns(r.data || []); }
    catch (e) { /* ignore */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const connect = async (provider) => {
    try { const r = await axios.get(`${API_URL}/api/cloud/${provider}/auth-url`); window.location.href = r.data.url; }
    catch (e) { alert(e?.response?.data?.detail || 'OAuth not configured'); }
  };

  const update = async (id, patch) => {
    try { await axios.put(`${API_URL}/api/cloud/connections/${id}`, patch); load(); }
    catch (e) { alert('Failed'); }
  };

  const disconnect = async (id) => {
    if (!window.confirm('Disconnect this cloud destination?')) return;
    await axios.delete(`${API_URL}/api/cloud/connections/${id}`);
    load();
  };

  return (
    <div className="min-h-screen bg-midnight text-text-light">
      <SiteHeader />
      <div className="max-w-3xl mx-auto p-4 sm:p-6">
        <div className="mb-4"><BackLink to="/dashboard" label="Dashboard" /></div>
        <h1 className="font-serif text-3xl sm:text-4xl text-champagne mb-6 flex items-center gap-3"><Cloud className="w-8 h-8" />Cloud destinations</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
          <button onClick={() => connect('google_drive')} className="bg-white/[0.03] border border-white/10 rounded-xl p-5 text-left hover:bg-white/[0.06]">
            <div className="font-medium">Connect Google Drive</div>
            <div className="text-sm text-text-muted">Auto-export new media to your Drive folder.</div>
          </button>
          <button onClick={() => connect('dropbox')} className="bg-white/[0.03] border border-white/10 rounded-xl p-5 text-left hover:bg-white/[0.06]">
            <div className="font-medium">Connect Dropbox</div>
            <div className="text-sm text-text-muted">Auto-export new media to your Dropbox.</div>
          </button>
        </div>

        {loading && <div className="text-text-muted">Loading…</div>}
        {!loading && !conns.length && <div className="text-text-muted text-sm">No cloud destinations connected yet.</div>}

        {conns.map(c => (
          <div key={c.id} className="bg-white/[0.03] border border-white/10 rounded-xl p-5 mb-3">
            <div className="flex justify-between items-start mb-3">
              <div>
                <div className="font-medium flex items-center gap-2"><Check className="w-4 h-4 text-emerald-400" />{c.provider}</div>
                <div className="text-sm text-text-muted">{c.account_email}</div>
                {c.last_sync_at && <div className="text-xs text-text-muted mt-1">Last sync: {new Date(c.last_sync_at).toLocaleString()}</div>}
              </div>
              <button aria-label="Disconnect" onClick={() => disconnect(c.id)} className="text-red-400 hover:text-red-300"><Trash2 className="w-5 h-5" /></button>
            </div>
            <label className="flex items-center gap-2 text-sm mb-1">
              <input type="checkbox" checked={c.auto_export_enabled} onChange={e => update(c.id, { auto_export_enabled: e.target.checked })} />
              Auto-export new uploads
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" checked={c.default_for_new_auras} onChange={e => update(c.id, { default_for_new_auras: e.target.checked })} />
              Default destination for new events
            </label>
          </div>
        ))}
      </div>
      <FooterExpanded />
    </div>
  );
}
